import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import HttpHelper from 'Services/HttpHelper'

export const validatePhoneNumber = async (phoneNumber) => {
    const response = await HttpHelper.Get({ url: `https://member-calls2.unicity.com/validate/phone-with-country-code?country=${storeCountry.Country2()}&phone=${phoneNumber}&isValidateOnlyMobile=1` })
    return response
}